import { useEffect } from "react";

function setMeta(attr, key, value) {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href, hreflang) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Renders SEO into <head> and applies lang/dir. Backend SSR remains the crawler source of truth.
export function useSeoHead(payload) {
  useEffect(() => {
    if (!payload) return;
    const { seo, lang, dir, jsonld } = payload;
    document.title = seo.title;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    setMeta("name", "description", seo.meta_desc);
    setMeta("name", "robots", seo.robots);
    setMeta("property", "og:title", seo.og_title);
    setMeta("property", "og:description", seo.og_desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", seo.canonical);
    setLink("canonical", seo.canonical);
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
    (seo.hreflang || []).forEach((h) => setLink("alternate", h.url, h.lang));
    document.head.querySelectorAll('script[data-seo-jsonld]').forEach((n) => n.remove());
    (jsonld || []).forEach((block) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(block);
      document.head.appendChild(s);
    });
  }, [payload]);
}
